export default __webpack_public_path__ + "static/media/topp.6be4ceeb.png";